"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChartUpdater = void 0;
const react_1 = require("react");
const fixedStreamSlice_1 = require("../../../../store/fixedStreamSlice");
const hooks_1 = require("../../../../store/hooks");
const mobileStreamSlice_1 = require("../../../../store/mobileStreamSlice");
const useChartUpdater = ({ chartComponentRef, seriesData, isLoading, fixedSessionTypeSelected, streamId, }) => {
    const dispatch = (0, hooks_1.useAppDispatch)();
    const lastSelectedTimeRange = (0, hooks_1.useAppSelector)((state) => fixedSessionTypeSelected
        ? state.fixedStream.lastSelectedTimeRange
        : state.mobileStream.lastSelectedTimeRange);
    const updateTimeoutRef = (0, react_1.useRef)(null);
    const lastTriggerRef = (0, react_1.useRef)(null);
    const hasInitializedRef = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        return () => {
            if (updateTimeoutRef.current) {
                clearTimeout(updateTimeoutRef.current);
            }
        };
    }, []);
    (0, react_1.useEffect)(() => {
        var _a;
        if (((_a = chartComponentRef.current) === null || _a === void 0 ? void 0 : _a.chart) &&
            seriesData &&
            seriesData.length > 0 &&
            streamId) {
            const chart = chartComponentRef.current.chart;
            if (chart.xAxis[0]) {
                const { min, max } = chart.xAxis[0].getExtremes();
                if (min !== undefined && max !== undefined) {
                    setTimeout(() => {
                        if (fixedSessionTypeSelected) {
                            dispatch((0, fixedStreamSlice_1.updateFixedMeasurementExtremes)({
                                streamId,
                                min,
                                max,
                            }));
                        }
                        else {
                            dispatch((0, mobileStreamSlice_1.updateMobileMeasurementExtremes)({
                                min,
                                max,
                            }));
                        }
                        hasInitializedRef.current = true;
                    }, 100);
                }
            }
        }
    }, [seriesData, isLoading, fixedSessionTypeSelected, streamId, dispatch]);
    const updateChartData = (0, react_1.useCallback)((chart, data) => {
        chart.series[0].setData(data, true, false, false);
        if (chart.xAxis[0]) {
            const { min, max } = chart.xAxis[0].getExtremes();
            if (min !== undefined && max !== undefined) {
                if (fixedSessionTypeSelected && streamId) {
                    dispatch((0, fixedStreamSlice_1.updateFixedMeasurementExtremes)({
                        streamId,
                        min,
                        max,
                    }));
                }
                else {
                    dispatch((0, mobileStreamSlice_1.updateMobileMeasurementExtremes)({
                        min,
                        max,
                    }));
                }
                hasInitializedRef.current = true;
            }
        }
    }, [fixedSessionTypeSelected, streamId, dispatch]);
    (0, react_1.useEffect)(() => {
        return () => {
            dispatch((0, fixedStreamSlice_1.resetTimeRange)());
            if (fixedSessionTypeSelected && streamId) {
                dispatch((0, fixedStreamSlice_1.resetFixedMeasurementExtremes)());
            }
        };
    }, [fixedSessionTypeSelected, streamId, dispatch]);
    return {
        updateChartData,
        lastTriggerRef,
    };
};
exports.useChartUpdater = useChartUpdater;
